import React from "react";

import { authRoles } from "app/auth";

import i18next from "i18next";

import vi from "./i18n/vi";
import en from "./i18n/en";
import { isMobileOnly } from "react-device-detect";

i18next.addResourceBundle("vi", "account", vi);
i18next.addResourceBundle("en", "account", en);

const AccountConfig = {
  settings: {
    layout: "admin",
  },
  auth: authRoles.user,
  routes: [
    {
      path: "/account",
      exact: true,
      component: React.lazy(() =>
        isMobileOnly ? import("./account.mobile") : import("./account")
      ),
    },
  ],
};

export default AccountConfig;
